<template>
  <div class="exchange vh100">
    <input v-model="code" type="text" placeholder="请输入兑换码" class="exchange-input">
    <UIButton  class="exchange-button" width="632" height="90" @click="submitCode">提交</UIButton>
    <p class="exchange-reminder" v-show="errorCode && !reminder">
      {{errorCode | errorFilter}}
    </p>
    <p class="exchange-reminder" v-show="reminder">
      {{reminder}}
    </p>
    <p class="exchange-record" @click="toPage('list')">
      兑换记录
    </p>
    <div class="exchange-rule" @click="toPage('rule')">
      了解兑换规则
    </div>
    <Notice class="exchange-notice" ref="notice" :closeBtn="true" width="480">
      <div class="exchange-notice-main">
        <img src="./images/icon-success.png" alt="">
        <h1>兑换成功</h1>
        <p>恭喜您获得</p>
        <p class="exchange-notice-main-title">{{exchangeName}}</p>
        <!--<p>有效期：{{ exchangeDate | dateFilter }}</p>-->
        <UIButton class="exchange-notice-main-button" width="260" height="64" @click="handlerClick">立即查看</UIButton>
      </div>
    </Notice>
  </div>
</template>

<script>

import UIButton from '../../components/UI/Button'
import Notice from '../../components/Notice'
import { format_filter } from '../../lib/dateUtils'
export default {
  data () {
    return {
      code: '',
      reminder: ''
    }
  },
  props: ['exchangeName', 'exchangeDate', 'errorCode', 'type'],
  filters: {
    dateFilter: t => format_filter(t)('YYYY-MM-DD'),
    errorFilter: (val) => {
      switch (val) {
        case 1020:
          return '兑换码不存在'
        case 1021:
          return '兑换码已使用'
        case 1022:
          return '兑换码已过期'
        case 1024:
          return '已拥有该课程'
        case 1028:
          return '已拥有该课程'
      }
    }
  },
  methods: {
    submitCode () {
      if (!this.code) {
        this.reminder = '请先输入兑换码'
        return
      }
      this.reminder = ''
      this.$emit('submitCode', {
        code: this.code,
        showNotice: this.$refs.notice.show
      })
    },
    handlerClick () {
      if (this.type === 1) {
        this.$router.push('/today')
      } else {
        this.$router.push('/vip')
      }
    },
    toPage (path) {
      this.$router.push(path)
    }
  },
  created () {
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.errorCode = 0
    })
  },
  components: {
    UIButton,
    Notice
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.exchange {
  text-align: center;
  padding-top: rem(60);
  position: relative;
  &-input {
    width: rem(630);
    height: rem(90);
    background-color: #F7F7F7;
    border: rem(2) solid #979797;
    border-radius: rem(8);
    text-align: center;
    margin-bottom: rem(40);
  }
  &-button {
    margin: auto;
    font-weight: bold;
  }
  &-reminder {
    margin-top: rem(30);
    font-size: rem(28);
    color: #FF4F59;
  }
  &-record {
    position: absolute;
    left: 50%;
    top: rem(340);
    transform: translateX(-50%);
    font-size: rem(30);
    color: #F48F00;
    margin-top: rem(40);
  }
  &-rule {
    position: absolute;
    color: #999999;
    font-size: rem(28);
    bottom: rem(120);
    width: 100%;
  }
  &-notice {
    &-main {
      padding: rem(50) 0;
      line-height: 1.5;
      > img {
        width: rem(80);
        margin-bottom: rem(15);
      }
      h1 {
        font-size: rem(36);
        font-weight: bold;
        margin-bottom: rem(34);
      }
      p {
        font-size: rem(30);
      }
      &-title {
        color: #F59100;
      }
      &-button {
        margin: rem(70) auto 0;
        font-weight: bold;
      }
    }
  }
}
</style>
